import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=1dd77b77"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports